import { IDs } from '../../../helpers/IDs';
import parse from 'html-react-parser';
import { setTempLog } from '../../../main/functions/tempLog';
import { i18nLang } from '../../../i18n/i18nLang';

export function renderText(textKey: string, data: any, noParsing?: boolean, noErrMsg?: boolean): any {
    data = data || {};
    const bereich_key: string = ((data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).bereich_key_orig || null;

    if (!(data[IDs.ENT_SYSTEMTEXTE] || []).length) {
        return null;
    }
    const whitelist: any[] = [];
    const regulated: any = {};

    // console.log('Systemtext', bereich_key, data[IDs.ENT_SYSTEMTEXTE_ZUORDNUNG]);

    (data[IDs.ENT_SYSTEMTEXTE_ZUORDNUNG] || []).forEach((item: any) => {
        if ((item.bereich_key_orig || item.bereich_key || '') === bereich_key && item.systemtext) {
            whitelist.push(item.systemtext_orig || item.systemtext);
        }
        regulated[item.systemtext_orig] = true;
    });
    let beschreibung = '';
    const beschreibung_arr = (data[IDs.ENT_SYSTEMTEXTE] || []).filter((item: any) => item.name === textKey &&
        (!regulated[item.tid] || whitelist.indexOf(item.tid) !== -1));
    // console.log('Systemtext L', regulated, whitelist, beschreibung_arr);
    const lang = i18nLang.getUILang();
    beschreibung_arr.forEach((item: any) => beschreibung += (item[`beschreibung_${lang}`] || item.beschreibung));

    let res = beschreibung
        ? (noParsing ? beschreibung : parse(beschreibung))
        : null;

    if (!res) {
        if (!noErrMsg) {
            res = `Fehlender Text: Kennung "${textKey}"`;
        }
        setTempLog({ name: 'Systemtext fehlt', description: textKey });
    }
    return res;
}

export function isEnableEnergiesteuerrueckerstattung(konfiguration: any[]): boolean {
    return konfiguration.some((param: any) => param.energiesteuerrueckerstattung_orig === 1);
}

export function isEnableErneuerbareEnergien(konfiguration: any[]): boolean {
    return konfiguration.some((param: any) => param.daten_erneuerbare_energien_orig === 1);
}

export function isEnableFahrzeuge(konfiguration: any[]): boolean {
    return konfiguration.some((param: any) => param.daten_fahrzeuge_orig === 1);
}

export function isEnableMaschinen(konfiguration: any[]): boolean {
    return konfiguration.some((param: any) => param.daten_maschinen_orig === 1);
}

export function isEnableStandorte(konfiguration: any[]): boolean {
    return konfiguration.some((param: any) => param.mehrere_standorte_orig === 1);
}
export function isEnableVeranstaltungen(konfiguration: any[]): boolean {
    return konfiguration.some((param: any) => param.veranstaltungen_orig === 1);
}

export function isEnableCO2(konfiguration: any[]): boolean {
    return IDs.FLAG_ENABLE_SCOPE3 && konfiguration.some((param: any) => param.co2_fussabdruck_orig === 1);
}

export function isEnableSachanlagen(konfiguration: any[]): boolean {
    return /*IDs.FLAG_ENABLE_SCOPE3 && */konfiguration.some((param: any) => param.co2_fussabdruck_sachanlagen_orig === 1);
}

export function isEnableGHG(konfiguration: any[]): boolean {
    return IDs.FLAG_ENABLE_SCOPE3 && konfiguration.some((param: any) => param.co2_fussabdruck_modus === 'ghg');
}

export function getBtnCalculatorKey(entity: string, jahr: number, values: any, idx = 0) {
    const energietraeger_tid = typeof values.energietraeger_tid_orig === 'number' ? values.energietraeger_tid_orig : values.energietraeger_tid;
    const words = ['calc', entity, jahr, energietraeger_tid || 0, idx];
    const btnKey = words.join('-');
    // console.log(btnKey);
    return btnKey;
}

export function getDlgCalculatorKey(entity: string, jahr: number, condit1: string) {
    const words = ['calc', 'dlg', entity, jahr, condit1];
    const btnKey = words.join('-');
    // console.log(btnKey);
    return btnKey;
}

export function getAutoSaveIntervall(konfiguration: any[]): number {
    const intervall = konfiguration && konfiguration[0] && konfiguration[0].auto_save_intervall > 0 ?
        konfiguration[0].auto_save_intervall * 1000 : 2000;
    return intervall;
}
